module.exports = __webpack_public_path__ + "img/pre_bar.c7340e1d.png";